import { LitElement, html, css } from 'lit'
import { focusTrap } from '../../lib/focus-trap'
import $ from 'quantdom'

export class ModalItem extends LitElement {
  //setting z-index to 1000001 to ensure it is on top of the accouncement bar
  static styles = [
    css`
      :host {
        display: block;
      }

      .modal-container {
        display: none;
        top: 0px;
        position: absolute;
        height: 100vh;
        position: fixed;
        bottom: 0px;
        left: 0px;
        z-index: 10000001;
        height: 100%;
        width: 100%;
      }

      .modal-container[aria-expanded='true'] {
        display: block;
      }

      .modal {
        display: none;
        position: absolute;
        z-index: 1000001;
        left: 50%;
        transform: translate(-50%, 0%);
        width: 100%;
        height: 100%;
        border-radius: 5px;
      }

      .modal[aria-expanded='true'] {
        display: flex;
        align-items: center;
      }

      @media (max-width: 550px) {
        .modal {
          /* max-height: calc(100vh - 40px); */
          /* max-width: calc(100vw - 150px); */
        }
      }

      slot[name='close'] {
        display: none;
      }

      slot[name='close'][aria-expanded='true'] {
        display: block;
      }
    `,
  ]

  static properties = {
    open: { type: Boolean, reflect: true },
    id: { type: String, reflect: true },
  }

  connectedCallback() {
    super.connectedCallback()

    window.MicroBus.on(`${this.id}:modal:toggle`, (e) => {
      this._toggle()
    })

    this.focusTrap = new focusTrap({
      el: this,
      includeActiveElement: true,
      escCallback: () => {
        this._toggle()
      },
    })

    $(this).on('click', (e) => {
      if (e.target.id === this.id) this._toggle()

      if (e.target.attributes['data-modal-close-btn'] || e.target.closest('[data-modal-close-btn]')) this._close()
    })
  }

  render() {
    // show when ready
    document.addEventListener('DOMContentLoaded', () => {
      $('modal-item').show()
    })

    return html`
      <div class="modal-container" aria-expanded=${this.open}>
        <div class="modal" aria-expanded=${this.open}>
          <slot></slot>
          <slot name="close" aria-expanded="${this.open}" @click=${this._close}></slot>
        </div>
      </div>
      <body-overlay id="${this.id}-overlay" top="0px" @click=${this._close}></body-overlay>
    `
  }

  _close() {
    window.MicroBus.emit(`${this.id}:modal:toggle`)
  }

  _toggle() {
    this.open = !this.open
    if (this.open) {
      this.removeAttribute('hidden')
      this.focusTrap.activate()
      window.addEventListener('click', this.windowClickHandler)
    } else {
      this.focusTrap.deactivate()
      window.removeEventListener('click', this.windowClickHandler)
      this.setAttribute('hidden', 'true')
    }
    window.MicroBus.emit(`${this.id}-overlay:toggle`, { closeEvent: `${this.id}:modal:toggle` })
  }
}

customElements.define('modal-item', ModalItem)
